import { render, staticRenderFns } from "./SettingsPreview.vue?vue&type=template&id=6a161572&"
import script from "./SettingsPreview.vue?vue&type=script&lang=js&"
export * from "./SettingsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports